const memberTypes = [
  { value:"POLICY_HOLDER", label:"Policy Holder" },
  { value:"SPOUSE", label:"Spouse" },
  { value:"PARENT", label:"Parent" },
  { value:"CHILD", label:"Child" }
]

export default memberTypes